import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import ShipsMap from '../../components/shipsmap/ShipsMap'
import ShipVisitList from '../../components/shipVisitList/ShipVisitList'
import ErrorBoundary from '../../components/errorBoundary/ErrorBoundary'
import { fetchShipsUsingAMmsilistFromBackend, fetchAllShipDetailsInTheRadius } from '../../js/rest'
import { getConflicts } from '../../utils/terminalVisitConflictsUtils'
import './MapPage.scss'

class MapPage extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      selectedShip: null,
      selectedTerminalVisits: [],
      filteredTerminalVisits: [],
      hoveredShip: ''
    }
  }

  static propTypes = {
    customFetch: PropTypes.func.isRequired
  }

  render() {
    const { conflicts } = getConflicts(
      this.allTerminalVisits(),
      this.props.app.present.config.quays,
      this.props.app.present.config.etaTooLateThreshold
    )
    const filteredTerminalVisits = this.state.filteredTerminalVisits

    return (
      <ErrorBoundary>
        <div className="content-wrapper map-page">
          <div className="content">
            <h2>Ships on map</h2>
            <div className="split-view">
              <div className="column content side">
                <ShipsMap
                  config={this.props.app.present.config}
                  selectedShip={this.state.selectedShip}
                  onSelectShip={this.handleSelectShip}
                  getShipsDetailsByMmsiList={this.getShipsDetailsByMmsiList}
                  getShipDetailsInTheRadius={this.getShipDetailsInTheRadius}
                  terminalVisits={
                    filteredTerminalVisits && filteredTerminalVisits.length
                      ? filteredTerminalVisits
                      : this.allTerminalVisits()
                  }
                  zoomToFitShips={false}
                  filters={this.state.filters}
                  showShipPopupWithEta={false}
                  hoveredShip={this.state.hoveredShip}
                />
              </div>
              <div className="column content side">
                <ShipVisitList
                  terminalVisits={this.allTerminalVisits()}
                  selectedVisit={null}
                  selectedVisits={this.state.selectedTerminalVisits}
                  onSelectVisit={this.handleSelectTerminalVisit}
                  statuses={['assigned', 'nearby', 'moored', 'sailed']}
                  getFilteredTerminalVisits
                  onChangeFilter={this.handleChangeFilter}
                  conflicts={conflicts}
                  quays={this.props.app.present.config.quays}
                  hoveredShip={this.handleShowShipPopup}
                />
              </div>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    )
  }
  getShipDetailsInTheRadius = async (center, radius) => {
    return fetchAllShipDetailsInTheRadius(center, radius, this.props.login.auth.token, this.props.customFetch)
  }

  getShipsDetailsByMmsiList = async mmsilist => {
    return fetchShipsUsingAMmsilistFromBackend(mmsilist, this.props.login.auth.token, this.props.customFetch)
  }

  allTerminalVisits = () => {
    return this.props.app.present.terminalVisits.filter(terminalVisit => terminalVisit.ship && terminalVisit.ship.mmsi)
  }

  handleSelectShip = mmsi => {
    this.setState({
      selectedShip: mmsi,
      selectedTerminalVisits: this.allTerminalVisits().filter(tv => tv.ship.mmsi === mmsi)
    })
  }

  handleDeselectShip = () => {
    this.setState({
      selectedShip: null,
      selectedTerminalVisits: []
    })
  }

  handleSelectTerminalVisit = terminalVisit => {
    if (terminalVisit && terminalVisit.ship && terminalVisit.ship.mmsi) {
      this.handleSelectShip(terminalVisit.ship.mmsi)
    } else {
      this.handleDeselectShip()
    }
  }

  handleChangeFilter = filteredTerminalVisits => {
    this.setState({ filteredTerminalVisits })
  }

  handleShowShipPopup = shipMMSI => {
    this.setState({ hoveredShip: shipMMSI })
  }
}

export default connect(state => state)(MapPage)
